import styled from 'styled-components';
import { darken } from 'polished';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  text-align: center;

  span {
    color: #fff;
    padding: 10px 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    flex: 1;
    background: #626ed4;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;

    & + button {
      margin-left: 10px;
      background: #ec4561;
    }
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const NewButton = styled(Link)`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  svg {
    margin-right: 5px;
  }
`;
